// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3240":"afb5d69b","7443":"afb5d69b","8654":"47f6c7ea"}[chunkId] + ".chunk.css";
};